module.exports = __webpack_public_path__ + "static/media/Ellipse2.503be253.png";